import { jsonArrayMember, jsonMember, jsonObject } from 'typedjson';
import { WarehouseFileRequest } from './warehouse-file.request';
import { Nillable } from '@web/utils';
import { WarehouseReceiptProductUpdateRequest } from './warehouse-receipt-product-update.request';
import { dateWithOffsetSerializer } from '@web/common';

@jsonObject
export class WarehouseReceiptUpdateRequest {
  @jsonMember(Date, { serializer: dateWithOffsetSerializer() })
  public receiptedAt!: Date;

  @jsonMember(String)
  public comment?: Nillable<string>;

  @jsonArrayMember(WarehouseReceiptProductUpdateRequest)
  public goods!: WarehouseReceiptProductUpdateRequest[];

  @jsonArrayMember(WarehouseFileRequest)
  public files!: WarehouseFileRequest[];

  public constructor(
    receiptedAt: Date,
    goods: WarehouseReceiptProductUpdateRequest[],
    files: WarehouseFileRequest[],
    comment?: Nillable<string>,
  ) {
    this.receiptedAt = receiptedAt;
    this.goods = goods;
    this.files = files;
    this.comment = comment;
  }
}
